var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.3042 5.52289C6.52378 2.97289 7.8342 1.93164 10.7029 1.93164H10.795C13.9613 1.93164 15.2292 3.19956 15.2292 6.36581V10.9841C15.2292 14.1504 13.9613 15.4183 10.795 15.4183H10.7029C7.85545 15.4183 6.54503 14.3912 6.31128 11.8837",
    stroke: "#8899B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.4165 8.66797H10.5398",
    stroke: "#8899B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.96045 6.29492L11.3334 8.66784L8.96045 11.0408",
    stroke: "#8899B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.da38d151cab979ddc7f57fbd1b02aad9.svg";
export { ForwardRef as ReactComponent };